// removed by extract-text-webpack-plugin
module.exports = {"wrap":"Menu-wrap","item":"Menu-item","selectedItem":"Menu-selectedItem","logo":"Menu-logo","logoNoName":"Menu-logoNoName","name":"Menu-name"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/Menu.scss
// module id = 1051
// module chunks = 10